import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { AuthService } from "../../service/auth.service";
import { BookingService } from "../../service/booking.service";
import { Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit";
import { CompanyProductSuggestionComponent } from "../../tables-custom-actions/company-product-suggestion.component";
import { CompanyProductSuggestionCompleteProfileComponent } from "../../tables-custom-actions/company-product-suggestion-complete-profile.component";
import { TranslocoService } from "@jsverse/transloco";

@Component({
  selector: "app-complete-profile",
  templateUrl: "./complete-profile.component.html",
  styles: [],
  standalone: false,
})
export class CompleteProfileComponent implements OnInit {
  constructor(
    private loader: LoaderService,
    private auth: AuthService,
    private booking: BookingService,
    private router: Router,
    private message: Message,
    private rest: RestService,
    private viewContainerRef: ViewContainerRef,
    private translocoService: TranslocoService
  ) { }
  showModalInfo = false
  canSkipProduct = true
  canSkipTime = true
  user: any = {};
  isCompanyComplete = false;
  company: any = {};
  salon: any = {};
  updateStepper = true;
  showModalSkipProduct = false
  showModalSkipTime = false
  dataStepper = [
    {
      status: "success",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Scegli un piano",
    },
    {
      status: "working",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Completa dettagli azienda",
    },
    {
      status: "incomplete",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Crea un salone",
    },
    {
      status: "incomplete",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Crea un'operatore",
    },
    {
      status: "incomplete",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Crea un prodotto",
    },
    {
      status: "incomplete",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Crea orari salone",
    },
  ];
  salonForm: any = new FormData();
  salonImageUrl = "";
  operatorImageUrl = "";
  productImageUrl = "";
  operator: any = {};
  operatorForm: any = new FormData();
  productForm: any = new FormData();
  product: any = {};
  listOfAddedProducts: any[] = [
  ]
  listOfAddedTimes: any[] = [
  ]
  showProducts = true
  showTime = true
  timeTable: any = {
    timeStart: "00:00",
    timeEnd: "00:00",
  };
  subcategoriesList: any[] = [];
  categoriesList: any[] = [];
  productSelect = {
    service: null,
    category: null
  }

  ngOnInit(): void {
    this.loader.on();
    this.auth.getMe().subscribe({
      next: (value) => {
        this.user = value;
        this.booking.getMyCompany().subscribe({
          next: (valueSub: any) => {
            this.loader.off(true);
            this.company = valueSub[0];
            this.isCompanyComplete =
              valueSub[0].address &&
              valueSub[0].city &&
              valueSub[0].companyName &&
              valueSub[0].country &&
              valueSub[0].email &&
              valueSub[0].phoneNumber &&
              valueSub[0].state &&
              valueSub[0].zipcode;
            if (
              this.isCompanyComplete &&
              this.user.noOfSalons > 0 &&
              this.user.noOfOperators > 0 &&
              this.user.noOfProducts > 0 &&
              this.user.noOfTimetables > 0
            ) {
              window.location.replace("prenotazioni");
            }
            if (this.isCompanyComplete) {
              this.dataStepper[1].status = "success";
              this.dataStepper[2].status = "working";
              this.salon = {
                email: this.company.email,
                name: this.company.companyName,
                address: this.company.address,
                city: this.company.city,
                phoneNumber: this.company.phoneNumber,
                zipcode: this.company.zipcode,
                state: this.company.state,
                country: this.company.country
              }
            }
            if (this.user.noOfSalons > 0) {
              this.dataStepper[2].status = "success"; this.dataStepper[3].status = "working";
            }
            if (this.user.noOfOperators) {
              this.dataStepper[3].status = "success"; this.dataStepper[4].status = "working";
            }
            if (this.user.noOfProducts) {
              this.dataStepper[4].status = "success"; this.dataStepper[5].status = "working";
            }
            if (this.user.noOfTimetables) {
              this.dataStepper[5].status = "success";
            }
            this.updateStepper = false;
            setTimeout(() => {
              this.updateStepper = true;
            }, 0);
          },
          error: () => {
            this.loader.off(true);
          },
        });
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
    this.rest.get("/subcategories/all").subscribe({
      next: (value: any) => {
        this.subcategoriesList = value;
      },
      error: (value) => { },
    });
    this.rest.get("/categories/all").subscribe({
      next: (value: any) => {
        this.categoriesList = value;
      },
      error: (value) => { },
    });
  }

  showModal() {
    setTimeout(() => {
      this.showModalInfo = true
    }, 0);

  }
  suggestionProduct() {
    setTimeout(() => {
      this.showProducts = false
      const componentRef = this.viewContainerRef.createComponent(CompanyProductSuggestionCompleteProfileComponent);
      componentRef.instance.fatherElement = {};
      componentRef.instance.fatherContaierRef = this;
    }, 0);
  }

  useSuggested(item: any) {
    let serviceId = item.serviceId
    let categoryId = item.categoryId
    let myCategory = this.categoriesList.find((res: any) => res.id == categoryId)
    let myService = this.subcategoriesList.find((res: any) => res.id == serviceId)
    this.productSelect = {
      category: myCategory,
      service: myService
    }
    this.product = item
    this.product.days = this.product.days.toString()
    this.showProducts = true
  }

  manageSelectProduct(event: any, name: string) {
    this.product[name] = event.id;
  }

  manageSelectTimeTable(event: any, name: string) {
    this.timeTable[name] = event.value;
  }

  saveSalon(t: any) {
    this.loader.on();
    for (const [key, value] of Object.entries(this.salon)) {
      this.salonForm.append(key, value);
    }
    this.rest.post("/salon", this.salonForm).subscribe({
      next: (value) => {
        this.user.noOfSalons = 1;
        this.message.showMessage(t("savedNextStep"), "success");
        this.loader.off();
        if (this.user.noOfSalons > 0) {
          this.dataStepper[2].status = "success";
          this.dataStepper[3].status = "working";
          this.updateStepper = false;
          setTimeout(() => {
            this.updateStepper = true;
          }, 0);
        }
      },
      error: (err) => {
        this.message.showMessage(
          t("savedError") + ":" + JSON.stringify(err),
          "error"
        );
        for (const [key, value] of Object.entries(this.salon)) {
          this.salonForm.delete(key);
        }
        this.loader.off();
      },
    });
  }

  saveTimteTable(t: any) {
    this.loader.on();
    this.rest.get(`/salon`).subscribe({
      next: (salons: any) => {
        this.rest
          .post(`/salon/${salons.data[0].id}/timetables`, this.timeTable)
          .subscribe({
            next: (value) => {
              this.message.showMessage(t("profileCompleted"), "success");
              this.loader.off();
              this.listOfAddedTimes.push(this.timeTable)

              this.timeTable = {}
              this.canSkipTime = false
              this.showTime = false
              setTimeout(() => {
                this.showTime = true
              }, 0);

            },
            error: (err) => {
              this.message.showMessage(
                t("savedError") + ":" + JSON.stringify(err),
                "error"
              );
              this.loader.off();
            },
          });
      },
    });
  }

  saveProduct(t: any) {
    this.loader.on();
    for (const [key, value] of Object.entries(this.product)) {
      this.productForm.append(key, value);
    }
    this.rest
      .post(`/company/${this.company.id}/item`, this.productForm)
      .subscribe({
        next: (value) => {
          let productToAdd = this.product
          productToAdd.imageToSee = this.productImageUrl
          this.listOfAddedProducts.push(productToAdd)
          this.product = {}
          this.productForm = new FormData()

          this.productImageUrl = ""
          this.loader.off(); this.canSkipProduct = false
          this.showProducts = false
          setTimeout(() => {
            this.showProducts = true
          }, 0);
        },
        error: (err) => {
          this.message.showMessage(
            t("savedError") + ":" + JSON.stringify(err),
            "error"
          );
          this.loader.off();
        },
      });
  }

  continueProduct(t: any) {
    this.dataStepper[4].status = "success";
    this.dataStepper[5].status = "working";
    this.message.showMessage(t("savedNextStep"), "success");
    this.showModalSkipProduct = false
    this.user.noOfProducts = 1;
    this.updateStepper = false;
    setTimeout(() => {
      this.updateStepper = true;
    }, 0);
  }

  continueTime(t: any) {
    this.message.showMessage(t("savedNextStep"), "success");
    this.showModalSkipTime = false
    this.translocoService.selectTranslateObject("routes").subscribe((route) => {
      window.location.replace(route.userDashboard.path)
    })
  }


  saveOperator(t: any) {
    this.loader.on();
    for (const [key, value] of Object.entries(this.operator)) {
      this.operatorForm.append(key, value);
    }
    this.rest
      .post(`/company/${this.company.id}/operator`, this.operatorForm)
      .subscribe({
        next: (value) => {
          this.user.noOfOperators = 1;
          this.message.showMessage(t("savedNextStep"), "success");
          this.loader.off();
          if (this.user.noOfOperators) {
            this.dataStepper[3].status = "success";
            this.dataStepper[4].status = "working";
            this.updateStepper = false;
            setTimeout(() => {
              this.updateStepper = true;
            }, 0);
            window.location.reload()
          }
        },
        error: (err) => {
          this.message.showMessage(
            t("savedError") + ":" + JSON.stringify(err),
            "error"
          );
          this.loader.off();
        },
      });
  }

  clickOperatorImage() {
    let inputOperatorImage = document.getElementById("select-operator-image");
    if (inputOperatorImage) {
      inputOperatorImage.click();
    }
  }

  clickProductImage() {
    let inputProductImage = document.getElementById("select-product-image");
    if (inputProductImage) {
      inputProductImage.click();
    }
  }

  clickSalonImage() {
    let inputSalonImage = document.getElementById("select-salon-image");
    if (inputSalonImage) {
      inputSalonImage.click();
    }
  }

  salonImage(event: any) {
    this.salonForm = new FormData();
    this.salonForm.append("file", event.target.files[0]);
    this.salonImageUrl = URL.createObjectURL(event.target.files[0]);
  }

  operatorImage(event: any) {
    this.operatorForm = new FormData();
    this.operatorForm.append("file", event.target.files[0]);
    this.operatorImageUrl = URL.createObjectURL(event.target.files[0]);
  }

  productImage(event: any) {
    this.productForm = new FormData();
    this.productForm.append("file", event.target.files[0]);
    this.productImageUrl = URL.createObjectURL(event.target.files[0]);
  }

  saveCompany(t: any) {
    this.loader.on();
    this.rest.put("/company/" + this.company.id, this.company).subscribe({
      next: (value) => {
        this.isCompanyComplete = true;
        this.message.showMessage(t("savedNextStep"), "success");
        this.loader.off();
        if (this.isCompanyComplete) {
          this.dataStepper[1].status = "success";
          this.dataStepper[2].status = "working";
          this.salon = {
            email: this.company.email,
            name: this.company.companyName,
            address: this.company.address,
            city: this.company.city,
            phoneNumber: this.company.phoneNumber,
            zipcode: this.company.zipcode,
            state: this.company.state,
            country: this.company.country
          }
          this.updateStepper = false;
          setTimeout(() => {
            this.updateStepper = true;
          }, 0);
        }
      },
      error: (err) => {
        this.message.showMessage(
          t("savedError") + ":" + JSON.stringify(err),
          "error"
        );
        this.loader.off();
      },
    });
  }

  goTo(url: string) {
    this.router.navigate([url]);
  }

  goToFirstSalon(t: any) {
    this.loader.on();
    this.booking.getMySalons().subscribe({
      next: (value: any) => {
        this.loader.off();
        if (value.length > 0) {
          this.router.navigate(["salone/" + value[0].id]);
        } else {
          this.message.showMessage(t("needSalon"), "error");
          this.router.navigate(["saloni"]);
        }
      },
      error: (value) => {
        this.loader.off();
      },
    });
  }
}
